import {
  StudiosModuleConfig,
  ArtistModuleConfig,
  AboutUsModuleConfig,
  StreamModuleConfig,
  ShopModuleConfig,
  SettingsModuleConfig,
  VipModuleConfig,
  WayFinderModuleConfig,
  FanFeedModuleConfig,
  ForumModuleConfig,
  EngageModuleConfig,
  FanBoxModuleConfig,
  NewsModuleConfig,
  MenuModuleConfig,
  MadeAndMetModuleConfig,
  LoginModuleConfig
} from '../../reducers/modules-config/modulesConfig';

const getProperModules = function(club_id, modules, additionalPredicate) {
  const properModuleConfig = {
    AboutUsModuleConfig: {
      'e2952c70-69fd-489a-bf0a-8b982c8606aa': [ArtistModuleConfig],  // Lenovo
      '80bb6008-c287-4722-96a4-29b6b64a36d8': [ArtistModuleConfig],
      '9d1c8f5a-6477-40cb-b44b-d1e4667ced5b': [AboutUsModuleConfig], // ManchesterCity
      '7e4043e4-72f4-4891-b87d-31fbcca10284': [StudiosModuleConfig], //Metropolis
      'ed4a283c-2499-4295-b91c-0435922c9b22': [StudiosModuleConfig], //Sportapp
      '822034c4-8064-4a78-84c4-7a777ec272b3': [StudiosModuleConfig], //Patrick
      '80f53ef6-6373-11ea-bc55-0242ac130003': [AboutUsModuleConfig], //buetzer buebe
      'dd8af89b-65fa-48ba-8aa3-462e0500a677': [AboutUsModuleConfig], // LiVE Nightlife
      'd6322683-cf56-4173-9411-85a950727c80': [AboutUsModuleConfig], // Footballerista
      '96895b04-292c-44ec-9252-24f506c21e93': [AboutUsModuleConfig], // Maurice_Lacroix
      'c03979b2-8a8e-11ec-a8a3-0242ac120002': [AboutUsModuleConfig], //live.demo
      'c03979b2-8a8e-11ec-a8a3-0242ac120003': [AboutUsModuleConfig], //live.sandbox
      '16aa606c-2906-466e-a7c1-5113db784e30': [AboutUsModuleConfig], // noctunre
      'd194a18b-a00c-45a8-8c70-111111111111': [AboutUsModuleConfig], // live flutter #1
      'd194a18b-a00c-45a8-8c70-222222222222': [AboutUsModuleConfig], // live flutter #2
      '36b92e17-2966-4d55-a3da-f59f29e3db2f': [AboutUsModuleConfig] // RollingStones
    },
    FanFeedModuleConfig: {
      'e2952c70-69fd-489a-bf0a-8b982c8606aa': [FanFeedModuleConfig], // Lenovo
      '80bb6008-c287-4722-96a4-29b6b64a36d8': [FanFeedModuleConfig],
      '9d1c8f5a-6477-40cb-b44b-d1e4667ced5b': [FanFeedModuleConfig], // ManchesterCity
      '7e4043e4-72f4-4891-b87d-31fbcca10284': [MadeAndMetModuleConfig], //Metropolis
      'ed4a283c-2499-4295-b91c-0435922c9b22': [MadeAndMetModuleConfig], //Sportapp
      '822034c4-8064-4a78-84c4-7a777ec272b3': [MadeAndMetModuleConfig], //Patrick
      '80f53ef6-6373-11ea-bc55-0242ac130003': [FanFeedModuleConfig], //buetzer buebe
      'dd8af89b-65fa-48ba-8aa3-462e0500a677': [FanFeedModuleConfig], // LiVE Nightlife
      'd6322683-cf56-4173-9411-85a950727c80': [FanFeedModuleConfig], // Footballerista
      '96895b04-292c-44ec-9252-24f506c21e93': [FanFeedModuleConfig], // Maurice_Lacroix
      'c03979b2-8a8e-11ec-a8a3-0242ac120002': [FanFeedModuleConfig], //live.demo
      'c03979b2-8a8e-11ec-a8a3-0242ac120003': [FanFeedModuleConfig], //live.sandbox
      '16aa606c-2906-466e-a7c1-5113db784e30': [FanFeedModuleConfig], //noctunre
      'd194a18b-a00c-45a8-8c70-111111111111': [FanFeedModuleConfig], // live flutter #1
      'd194a18b-a00c-45a8-8c70-222222222222': [FanFeedModuleConfig], // live flutter #2
      '36b92e17-2966-4d55-a3da-f59f29e3db2f': [FanFeedModuleConfig] //RollingStones
    }
  };

  //the order of this modules is constant
  let commonModules = [
    LoginModuleConfig,
    MenuModuleConfig,
    AboutUsModuleConfig,
    VipModuleConfig,
    SettingsModuleConfig
  ];

  let allModules = [
    LoginModuleConfig,
    MenuModuleConfig,
    NewsModuleConfig,
    FanBoxModuleConfig
  ]
    .concat(properModuleConfig['AboutUsModuleConfig'][club_id])
    .concat([EngageModuleConfig, ForumModuleConfig])
    .concat(properModuleConfig['FanFeedModuleConfig'][club_id])
    .concat([
      WayFinderModuleConfig,
      StreamModuleConfig,
      ShopModuleConfig,
      VipModuleConfig,
      SettingsModuleConfig
    ]);

  let fetchedModulesTypes = modules.concat(commonModules.map(m => m.type));

  return allModules.filter(m => m!= undefined).filter(
    m => fetchedModulesTypes.some(n => n === m.type) && (additionalPredicate ? additionalPredicate(m) : true)
  );
};

export default getProperModules;



// WEBPACK FOOTER //
// ./src/reducers/modules-config/modulesGetter.js